module.exports = __webpack_public_path__ + "static/MOD0-21e3a49b1455dbd9e92ce573fae01abf.png";